/**
 * @file index.js
 * @author Fernando Ruano
 * @description Map Redux Crud.
 */

import { bindActionCreators } from 'redux';

// Redux Actions
import * as actions from '@nephro/redux/stores/app/actions';
import * as authActions from '@nephro/redux/stores/auth/actions';
import * as userActions from '@nephro/redux/stores/user/actions';
import * as patientActions from '@nephro/redux/stores/patient/actions';
import * as calendarActions from '@nephro/redux/stores/calendar/actions';
import * as profileActions from '@nephro/redux/stores/profile/actions';
import * as roleActions from '@nephro/redux/stores/role/actions';
import * as parameterActions from '@nephro/redux/stores/parameter/actions';
import * as medicalParameterActions from '@nephro/redux/stores/medical-parameter/actions';
import * as menuActions from '@nephro/redux/stores/menu/actions';
import * as countryUserRoleActions from '@nephro/redux/stores/country-user-role/actions';
import * as componentsStateActions from '@nephro/redux/stores/components-state/actions';
import * as bloodPressureActions from '@nephro/redux/stores/blood-pressure/actions';
import * as glucometryActions from '@nephro/redux/stores/glucometry/actions';
import * as patientEventActions from '@nephro/redux/stores/patient-event/actions';
import * as educationalElementActions from '@nephro/redux/stores/educational-element/actions';
import * as s3FileActions from '@nephro/redux/stores/s3-file/actions';
import * as educationalCategoryActions from '@nephro/redux/stores/educational-category/actions';
import * as dashboardStaffActions from '@nephro/redux/stores/dashboard-staff/actions';
import * as clinicPhonesActions from '@nephro/redux/stores/clinic-phones/actions';
import * as appointmentsZoomActions from '@nephro/redux/stores/appointments-zoom/actions';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToProps = (state) => {
  return {
    loading: state.getIn(['AppState', 'loading']),
    user: state.getIn(['AppState', 'user']),
    clinicId: state.getIn(['AppState', 'clinicId']),
    lastVersiaUpdate: state.getIn(['AppState', 'lastVersiaUpdate']),
    response: state.getIn(['AppState', 'response']).toJS(),
    patientIndicators: state.getIn(['AppState', 'patientIndicators']),
    patientEventType: state.getIn(['AppState', 'patientEventType']),
    clinics: state.getIn(['AppState', 'clinics']),
    insurers: state.getIn(['AppState', 'insurers']),
    tableConfig: state.getIn(['AppState', 'tableConfig'])
  };
};

/**
 * Map dispatch to props
 * @param dispatch - Run the  process to execute in the action
 * @returns { object }
 */
export const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  authActions: bindActionCreators(authActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch),
  patientActions: bindActionCreators(patientActions, dispatch),
  calendarActions: bindActionCreators(calendarActions, dispatch),
  roleActions: bindActionCreators(roleActions, dispatch),
  parameterActions: bindActionCreators(parameterActions, dispatch),
  medicalParameterActions: bindActionCreators(
    medicalParameterActions,
    dispatch
  ),
  menuActions: bindActionCreators(menuActions, dispatch),
  profileActions: bindActionCreators(profileActions, dispatch),
  countryUserRoleActions: bindActionCreators(countryUserRoleActions, dispatch),
  componentsStateActions: bindActionCreators(componentsStateActions, dispatch),
  bloodPressureActions: bindActionCreators(bloodPressureActions, dispatch),
  glucometryActions: bindActionCreators(glucometryActions, dispatch),
  patientEventActions: bindActionCreators(patientEventActions, dispatch),
  educationalElementActions: bindActionCreators(
    educationalElementActions,
    dispatch
  ),
  s3FileActions: bindActionCreators(s3FileActions, dispatch),
  educationalCategoryActions: bindActionCreators(
    educationalCategoryActions,
    dispatch
  ),
  dashboardStaffActions: bindActionCreators(dashboardStaffActions, dispatch),
  clinicPhonesActions: bindActionCreators(clinicPhonesActions, dispatch),
  appointmentsZoomActions: bindActionCreators(appointmentsZoomActions, dispatch)
});
